/** Every role in the platform. Order is the hierarchy, highest first. */
export const USER_ROLES = [
    "super_admin",
    "org_admin",
    "sales_rep",
    "distributor",
    "sub_distributor",
    "counter",
    "karigar",
];
/** Roles that belong to an organization. `super_admin` is the only one that does not. */
export const TENANT_ROLES = USER_ROLES.filter((r) => r !== "super_admin");
/** Human labels for UI. */
export const ROLE_LABELS = {
    super_admin: "Super Admin",
    org_admin: "Org Admin",
    sales_rep: "Sales Rep",
    distributor: "Distributor",
    sub_distributor: "Sub-Distributor",
    counter: "Counter",
    karigar: "Karigar",
};
/**
 * Which roles each role may create (D-09 strict tree).
 * Enforced server-side — never trust the UI to hide a button.
 */
export const CAN_CREATE = {
    super_admin: ["org_admin"],
    org_admin: ["sales_rep", "distributor", "sub_distributor", "counter", "karigar"],
    sales_rep: ["counter"],
    distributor: ["sub_distributor", "counter"],
    sub_distributor: ["counter"],
    counter: ["karigar"],
    karigar: [],
};
export function canCreate(actor, target) {
    return CAN_CREATE[actor].includes(target);
}
/** Roles that sign in with email + password (D-06). */
export const PASSWORD_ROLES = [
    "super_admin",
    "org_admin",
    "sales_rep",
    "distributor",
    "sub_distributor",
    "counter",
];
/** Roles that sign in with mobile + OTP (D-06). */
export const OTP_ROLES = ["karigar"];
/** Where each role lands after signing in. `:orgSlug` is substituted at runtime. */
export const ROLE_HOME = {
    super_admin: "/super-admin/organizations",
    org_admin: "/:orgSlug/admin",
    sales_rep: "/:orgSlug/sales",
    distributor: "/:orgSlug/sales",
    sub_distributor: "/:orgSlug/sales",
    counter: "/:orgSlug/counter",
    karigar: "/:orgSlug/karigar",
};
/** `displayId` prefix per role — SR-0001, CN-0001, KG-0001. */
export const ROLE_ID_PREFIX = {
    org_admin: "OA",
    sales_rep: "SR",
    distributor: "DS",
    sub_distributor: "SD",
    counter: "CN",
    karigar: "KG",
};
/** Only these roles receive personal QCoin earnings. */
export const QCOIN_EARNING_ROLES = ["counter", "karigar"];
export const canEarnQCoin = (role) => QCOIN_EARNING_ROLES.includes(role);
//# sourceMappingURL=roles.js.map